import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface TaxStatusDTO extends BaseIntDTO {
  taxStatus: string;
  taxDueDate: string;
}
